import TaskListService from '@/services/tasks/task-list-service'
import { alertSuccess } from '@/utilities/sweetalert'

export const state = {
  taskLists: [],
  taskList: {},
  assignedTaskLists: [],
  discussions: [],
  loading: {
    items: false,
    item: false,
    discussions: false
  }
}

export const getters = {
  taskLists: state => state.taskLists,
  taskList: state => state.taskList,
  assignedTaskLists: state => state.assignedTaskLists,
  discussions: state => state.discussions,
  loading: state => state.loading
}

export const actions = {
  fetchTaskLists({ commit }) {
    commit('SET_ITEMS_LOADING', true)

    TaskListService.index()
      .then(response => {
        commit('SET_TASK_LISTS', response.data)
      })
      .catch(() => {
        commit('SET_TASK_LISTS', [])
      })
      .then(() => {
        commit('SET_ITEMS_LOADING', false)
      })
  },

  fetchAssignedTaskLists({ commit }) {
    commit('SET_ITEMS_LOADING', true)

    TaskListService.indexAssigned()
      .then(response => {
        commit('SET_ASSIGNED_TASK_LISTS', response.data)
      })
      .catch(() => {
        commit('SET_ASSIGNED_TASK_LISTS', [])
      })
      .then(() => {
        commit('SET_ITEMS_LOADING', false)
      })
  },

  fetchTaskList({ commit }, id) {
    commit('SET_ITEM_LOADING', true)

    TaskListService.show(id)
      .then(response => {
        commit('SET_TASK_LIST', response.data)
      })
      .catch(() => {
        commit('SET_TASK_LIST', {})
      })
      .then(() => {
        commit('SET_ITEM_LOADING', false)
      })
  },

  storeTaskList({ commit }, payload) {
    return TaskListService.store(payload).then(response => {
      commit('projects/INSERT_TASK_LIST_TO_PROJECT', response.data, {
        root: true
      })

      alertSuccess({
        title: 'Task list susccessfully created.'
      })
    })
  },

  updateTaskList({ commit }, payload) {
    return TaskListService.update(payload.id, payload).then(response => {
      commit('SET_TASK_LIST', response.data)

      alertSuccess({
        title: 'Task list susccessfully updated.'
      })
    })
  },

  deleteTaskList({ commit }, id) {
    return TaskListService.delete(id).then(() => {
      commit('projects/REMOVE_TASK_LIST_FROM_PROJECT', id, {
        root: true
      })

      alertSuccess({
        title: 'Task list susccessfully deleted.'
      })
    })
  },

  fetchDiscussions({ commit }, discussable_id) {
    return TaskListService.indexDiscussions(discussable_id)
      .then(response => {
        commit('SET_DISCUSSIONS', response.data)
      })
      .catch(() => {
        commit('SET_DISCUSSIONS', [])
      })
  },

  storeDiscussion({ commit }, payload) {
    return TaskListService.storeDiscussion(
      payload.discussable_id,
      payload
    ).then(response => {
      commit('SET_DISCUSSIONS', response.data)
    })
  },

  updateDiscussion({ commit }, payload) {
    return TaskListService.updateDiscussion(
      payload.discussable_id,
      payload.id,
      payload
    ).then(response => {
      commit('SET_DISCUSSIONS', response.data)
    })
  },

  deleteDiscussion({ commit }, payload) {
    return TaskListService.deleteDiscussion(
      payload.discussable_id,
      payload.id
    ).then(response => {
      commit('SET_DISCUSSIONS', response.data)
    })
  }
}

export const mutations = {
  SET_TASK_LISTS(state, taskLists) {
    state.taskLists = taskLists
  },
  SET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  SET_ASSIGNED_TASK_LISTS(state, assignedTaskLists) {
    state.assignedTaskLists = assignedTaskLists
  },
  SET_DISCUSSIONS(state, discussions) {
    state.discussions = discussions
  },
  SET_ITEMS_LOADING(state, loading) {
    state.loading.items = loading
  },
  SET_ITEM_LOADING(state, loading) {
    state.loading.item = loading
  }
}
